import { forwardRef } from 'react';
import { IconButton } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { ResizeContainer } from './styled';
export const ResizeHandle = forwardRef((props, ref) => (<ResizeContainer ref={ref} {...props}>
    <IconButton $round size="small">
      <Falcon icon="arrows-maximize"/>
    </IconButton>
  </ResizeContainer>));
